.errorContainer {
  color: var(--color-red-700);
  font-size: 0.875rem;
  margin: 6px 0;

  &.errorContainer__disabled {
    opacity: 0.5;
  }

  :global {
    .anticon {
      font-size: 1rem;
    }
  }
}
